import { ProgressBar } from "@adeccoux/tag-ds";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { BaseContext } from "../../App";
import {
    CommonLoader,
    CommonPopup,
    CommonQuesProgress,
    QuesLoader,
    useScreenTransition,
    useTimer,
    redirectToAssessmentSummary,
} from "../../util/common";
import { TEST_COMPLETE, TEST_QUESTIONS } from "../../util/constants";
import { getNoCacheCall, postCall } from "../../util/resources";
import DragDrop from "../DragDrop/dragDrop";
import SesHeader from "../header";

const SurveyQues = () => {
    const [test, setTest] = useState();
    const [singleSelectData, setSingleSelectData] = useState("-1");
    const [freeFieldData, setFreeFieldData] = useState("");
    const [multiSelectData, setMultiSelectData] = useState("-1");
    const [textData, setTextData] = useState("");
    const [defaultOrderData, setDefaultOrderData] = useState([]);
    const [orderData, setOrderData] = useState([]);
    const [menuVisible, setMenuVisible] = useState(false);
    const [menuPosition, setMenuPosition] = useState({ x: 0, y: 0 });
    const textAreaRef = useRef(null);
    const divRef = useRef(null);
    const [popupData, setpopupData] = useState({
        isOpen: false,
        popupHeader: "",
        popupBody: "",
        popupFooter: "",
    });
    const { min, sec, totalSecLeft, startTimer, stopTimer } = useTimer();
    const location = useLocation();
    const phrases = location.state.user.siteConfig.phrases;
    const navigate = useNavigate();
    const formRef = useRef();
    const exampleTest = useRef();
    const quesNo = useRef(-1);
    const assessmentTimerStarted = useRef(false);
    const stepRef = useRef();
    const attachKeyListenRef = useRef();
    const keyMappings = useRef({});
    const header = useRef({
        "x-xpert-session": location.state.user.sessionId,
        "Content-Type": "application/json",
    });
    const firstPrev = useRef(0);
    const previewDataLocal = useRef(location.state.previewData);
    const { phase, loading, startTransition, done } = useScreenTransition();

    const buildMediaUrl = (file) => {
        let builtUrl =
            window.location.protocol +
            "//" +
            window.location.hostname +
            "/static";
        builtUrl += (file.startsWith("/") ? "" : "/") + file;
        return builtUrl;
    };
    const detectKeyDown = (e) => {
        e.preventDefault();
        if (!loading) {
            if (
                e.code in keyMappings.current &&
                test.questions[0].answers?.[0]?.groupId === "1"
            ) {
                setSingleSelectData(keyMappings.current[e.code]);
            } else if (
                e.code in keyMappings.current &&
                test.questions[0].answers?.[0]?.groupId === "2" &&
                !test.questions[0].allowRanking
            ) {
                updateMultiSelect(keyMappings.current[e.code]);
            }
            if (nextAllowed() && e.code === "Space") {
                nextNavigate();
            }
        }
    };

    const prepareMultiSelect = (answerArray, preVal = false) => {
        let temp = [];
        if (preVal !== false) {
            const userChoice = parseInt(answerArray, 10);
            const aa = preVal,
                aal = preVal.length;
            for (let i = 0; i < aal; i++) {
                if (userChoice & Math.pow(2, i) && userChoice !== -1) {
                    temp.push(true);
                } else {
                    temp.push(false);
                }
            }
        } else {
            temp = [...Array(answerArray.length)].map(() => {
                return false;
            });
        }
        setMultiSelectData(temp);
    };

    const prepareAns = () => {
        let answer = "";
        if (
            !test.questions[0].answers ||
            test.questions[0].answers?.length === 0
        ) {
            answer = "-1";
        } else {
            if (test.questions[0].answers?.[0]?.groupId === "1") {
                answer = singleSelectData;
            } else if (test.questions[0].answers?.[0]?.groupId === "2") {
                let av = null,
                    a;
                const aa = multiSelectData;
                const aal = aa.length;

                for (let i = 0; i < aal; i++) {
                    a = aa[i];
                    if (a) {
                        av += Math.pow(2, i);
                    }
                }
                answer = av;
            } else if (test.questions[0].answers?.[0]?.groupId === "3") {
                answer = textData;
            }
        }
        if (test.questions[0].freeField) {
            answer += "#$#" + freeFieldData;
        }
        return answer;
    };

    const nextAllowed = () => {
        if (
            test.questions[0].freeField &&
            (!test.questions[0].answers ||
                test.questions[0].answers?.length === 0)
        ) {
            return freeFieldData.length > 0;
        } else if (test.questions[0].allowRanking) {
            return true;
        } else if (test.questions[0].answers?.[0]?.groupId === "1") {
            return singleSelectData != "-1";
        } else if (test.questions[0].answers?.[0]?.groupId === "2") {
            let allowed = false;
            multiSelectData != "-1" &&
                multiSelectData.map((val, ind) => {
                    if (val) {
                        allowed = true;
                    }
                });
            return allowed;
        } else if (test.questions[0].answers?.[0]?.groupId === "3") {
            return textData.length > 0;
        }
    };

    const updateMultiSelect = (ind) => {
        setMultiSelectData((prev) => {
            let newArr = [...prev];
            newArr[ind] = !newArr[ind];
            return newArr;
        });
    };

    const generateKeyMapping = (answers) => {
        if (answers && answers?.length > 0) {
            let key;
            keyMappings.current = {};
            answers.map((val) => {
                key = `Digit${val.position + 1}`;
                keyMappings.current = {
                    ...keyMappings.current,
                    [key]: val.position,
                };
            });
        }
    };

    const nextNavigate = async (prev = false) => {
        startTransition(
            async () => {
                if (prev === true) {
                    quesNo.current -= 1;
                    firstPrev.current += 1;
                } else {
                    firstPrev.current = 0;
                }
                if (location.state.warmUp) {
                    if (test.lastPage && prev !== true) {
                        stopTimer();
                        navigate("/survey", {
                            state: { ...location.state, warmUp: false },
                        });
                    } else {
                        if (prev === true) {
                            quesNo.current -= 1;
                        }
                        await getQuestion();
                    }
                } else {
                    const elapsedTime = stopTimer();
                    let ansObj;
                    if (test.questions[0].allowRanking) {
                        let positionVal = "";
                        let ans = orderData.map((data, ind) => {
                            positionVal += positionVal.length > 0 ? "," : "";
                            positionVal += data.position;
                            return {
                                content: data.content,
                                groupId: data.groupId,
                                id: data.id,
                                position: data.position,
                                score: data.score,
                                position: ind,
                            };
                        });
                        ansObj = {
                            answers: ans,
                            structure: null,
                            value: positionVal,
                        };
                    } else {
                        ansObj = {
                            answers: [],
                            structure: null,
                            value: prepareAns().toString(),
                        };
                    }
                    let quesObj = test.questions;
                    quesObj[0].userAnswer = ansObj;
                    const otherData = {
                        duration:
                            location.state.test.timeByQuestion &&
                                location.state.test.bShowTimer
                                ? elapsedTime
                                : location.state.test.duration + elapsedTime,
                        pause: firstPrev.current === 1,
                    };
                    try {
                        let response;
                        if (prev === "timeEnded") {
                            stopTimer();
                            if (previewDataLocal.current) {
                                previewDataLocal.current[
                                    quesNo.current
                                ].questions = quesObj;
                            } else {
                                response = await postCall(
                                    TEST_COMPLETE + location.state.test.id,
                                    { ...otherData, questions: quesObj },
                                    header.current
                                );
                            }
                        } else if (test.lastPage && prev !== true) {
                            stopTimer();
                            if (previewDataLocal.current) {
                                previewDataLocal.current[
                                    quesNo.current
                                ].questions = quesObj;
                            } else {
                                response = await postCall(
                                    TEST_COMPLETE + location.state.test.id,
                                    { ...otherData, questions: quesObj },
                                    header.current
                                );
                            }
                        } else {
                            if (previewDataLocal.current) {
                                previewDataLocal.current[
                                    prev === true
                                        ? quesNo.current + 1
                                        : quesNo.current
                                ].questions = quesObj;
                            } else {
                                response = await postCall(
                                    TEST_QUESTIONS + location.state.test.id,
                                    { ...otherData, questions: quesObj },
                                    header.current
                                );
                            }
                        }
                        if (
                            response?.data?.status === true ||
                            previewDataLocal.current
                        ) {
                            if (test.lastPage && prev !== true) {
                                if(previewDataLocal.current){
                                    navigate('/');
                                }else{
                                    redirectToAssessmentSummary(location, navigate);
                                }
                            } else {
                                setSingleSelectData(-1);
                                setMultiSelectData(-1);
                                setFreeFieldData("");
                                setTextData("");
                                setOrderData([]);
                                formRef.current.reset();
                                if (prev !== true) quesNo.current += 1;
                                await getQuestion();
                            }
                        }
                    } catch (error) {
                        console.log(error);
                    }
                }
                done();
            },
            location.state.warmUp || previewDataLocal.current ? false : true
        );
    };

    const restoreAns = (data) => {
        if (data.questions[0].userAnswer !== null) {
            const userAnswer = data.questions[0].userAnswer.value.split("#$#");
            const userChoice = userAnswer[0];
            const userText = userAnswer[1] ? userAnswer[1] : "";
            if (data.questions[0].allowRanking) {
                let savedPos = userChoice.split(",");
                let defaultAns = [];
                let savedAnsArr = [];
                let quesAns = structuredClone(data.questions[0].answers);
                quesAns.map((val) => {
                    if (savedPos.some((sp) => sp == val.position.toString())) {
                        savedAnsArr.push(val);
                    } else {
                        defaultAns.push(val);
                    }
                });
                setDefaultOrderData(defaultAns);
                setOrderData(savedAnsArr);
            } else if (data.questions[0].answers?.[0]?.groupId === "1") {
                setSingleSelectData(userChoice);
            } else if (data.questions[0].answers?.[0]?.groupId === "2") {
                prepareMultiSelect(userChoice, data.questions[0].answers);
            } else if (data.questions[0].answers?.[0]?.groupId === "3") {
                setTextData(userChoice);
            }
            setFreeFieldData(userText);
        } else if (data.questions[0].allowRanking) {
            setDefaultOrderData(structuredClone(data.questions[0].answers));
        }
        if (
            data.questions[0].answers?.[0]?.groupId === "2" &&
            !data.questions[0].allowRanking &&
            data.questions[0].userAnswer === null
        ) {
            prepareMultiSelect(data.questions[0].answers, false);
        }
    };

    const getQuestion = async () => {
        if (location.state.warmUp) {
            setTest(exampleTest.current[quesNo.current]);
            quesNo.current += 1;
            if (
                exampleTest?.current[quesNo.current]?.questions[0]?.answers?.[0]
                    ?.groupId === "2" &&
                !exampleTest?.current[quesNo.current]?.questions[0]
                    ?.allowRanking
            ) {
                prepareMultiSelect(
                    exampleTest.current[quesNo.current].questions[0].answers,
                    false
                );
            }
        } else if (previewDataLocal.current) {
            setTest(previewDataLocal.current[quesNo.current]);
            generateKeyMapping(
                previewDataLocal.current[quesNo.current].questions[0].answers
            );
            restoreAns(previewDataLocal.current[quesNo.current]);
        } else {
            try {
                const response = await getNoCacheCall(
                    TEST_QUESTIONS +
                    location.state.test.id +
                    "/" +
                    quesNo.current,
                    header.current
                );
                quesNo.current = response.data[0].endNumber;
                setTest(response.data[0]);
                generateKeyMapping(response.data[0].questions[0].answers);
                restoreAns(response.data[0]);
                let dcTime = atob(response.data[0].questions[0].encTmLmt);
                let dcTimeFi = dcTime.split(":");
                if (
                    location.state.test.timeByQuestion &&
                    location.state.test.bShowTimer
                ) {
                    startTimer(parseInt(dcTimeFi[1], 10), "timeByQuestion");
                } else if (
                    location.state.test.bShowTimer &&
                    location.state.test.timeLimit &&
                    !assessmentTimerStarted.current
                ) {
                    const timeLimit = atob(location.state.test.encTmLmt).split(
                        ":"
                    )[1];
                    assessmentTimerStarted.current = timeLimit;
                    startTimer(timeLimit - location.state.test.duration);
                } else {
                    startTimer();
                }
            } catch (error) {
                console.log(error);
            }
        }
    };

    const exitTest = () => {
        if (location.state.warmUp) {
            navigate("/instructions", {
                state: { ...location.state, warmUp: false },
            });
        } else if (previewDataLocal.current) {
            window.close();
        } else {
            setpopupData((prev) => {
                prev = {
                    ...prev,
                    isOpen: true,
                    popupHeader: location.state.test.name,
                    popupBody: phrases?.["1002189"],
                    popupFooter: phrases?.["14392"],
                };
                return prev;
            });
        }
    };

    const closePopUp = () => {
        setpopupData((prev) => {
            prev = { ...prev, isOpen: false };
            return prev;
        });
        stopTimer();
        navigate("/");
    };

    const approveAction = async () => {
        const elapsedTime = stopTimer();
        const ansObj = {
            answers: [],
            structure: null,
            value: prepareAns(),
        };
        let quesObj = test.questions;
        quesObj[0].userAnswer = ansObj;
        if (
            location.state.test.timeByQuestion &&
            location.state.test.bShowTimer
        ) {
            quesObj[0].duration = elapsedTime;
        }
        const otherData = {
            duration:
                location.state.test.timeByQuestion &&
                    location.state.test.bShowTimer
                    ? elapsedTime
                    : location.state.test.duration + elapsedTime,
        };
        const response = await postCall(
            TEST_COMPLETE + location.state.test.id,
            { ...otherData, questions: quesObj },
            header.current
        );
        redirectToAssessmentSummary(location, navigate);
    };
    const handleClickOutside = (event) => {
        if (divRef.current && !divRef.current.contains(event.target)) {
            setMenuVisible(false);
        }
    };
    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        if (test) {
            if (
                location.state.test.bShowTimer &&
                !assessmentTimerStarted.current
            ) {
                assessmentTimerStarted.current = true;
                startTimer(
                    location.state.test.timeLimit - location.state.test.duration
                );
            }
            attachKeyListenRef.current?.focus({
                preventScroll: true,
            });
        }
    }, [test]);

    useEffect(() => {
        if (totalSecLeft === 0) {
            nextNavigate("timeEnded");
        }
        if (assessmentTimerStarted.current) {
            stepRef.current.children[1].children[0].setAttribute(
                "data-secLeft",
                `${min}:${sec}`
            );
        }
    }, [totalSecLeft]);

    useEffect(() => {
        setSingleSelectData(-1);
        setMultiSelectData(-1);
        setFreeFieldData("");
        setTextData("");
        setOrderData([]);
        if (location.state.warmUp) {
            exampleTest.current = location.state.test.testExample;
            quesNo.current = 0;
        }
        if (previewDataLocal.current) {
            quesNo.current = 0;
        }
        getQuestion();
    }, [location.state.warmUp]);

    if (!test) {
        return <CommonLoader />;
    }
    const handlePasteTemp = (e) => {
        if (location?.state?.test?.pasteAllowed) {
            e.stopPropagation();
        }
    };
    const handleCopyTemp = (e) => {
        if (location?.state?.test?.pasteAllowed) {
            e.stopPropagation();
        }
    };

    const handleContextMenu = (e) => {
        if (location?.state?.test?.pasteAllowed) {
            setMenuVisible(true);
            e.stopPropagation();
            e.preventDefault();
            const { clientX, clientY } = e;
            setMenuPosition({ x: clientX, y: clientY });
        }
    };

    const handleCopy = async () => {
        try {
            if (textAreaRef.current) {
                const selectedText = textAreaRef.current.value.substring(
                    textAreaRef.current.selectionStart,
                    textAreaRef.current.selectionEnd
                );
                await navigator.clipboard.writeText(selectedText);
            }
        } catch (err) {
            console.error("Failed to copy text:", err);
        }
        setMenuVisible(false);
    };

    const handlePaste = async () => {
        try {
            const clipboardText = await navigator.clipboard.readText();
            if (textAreaRef.current) {
                const textarea = textAreaRef.current;
                const cursorPosition = textarea.selectionStart;
                const textBefore = freeFieldData.substring(0, cursorPosition);
                const textAfter = freeFieldData.substring(cursorPosition);
                const updatedText = textBefore + clipboardText + textAfter;
                setFreeFieldData(updatedText);
            }
        } catch (err) {
            console.error("Failed to paste:", err);
        }
        setMenuVisible(false);
    };

    const handleSelectAll = () => {
        if (textAreaRef.current) {
            textAreaRef.current.select();
        }
        setMenuVisible(false);
    };

    return (
        <>
            <div
                className="g-container flex_col p4 g5 pt0_mobile g2_mobile full-width"
                style={{ outline: "none" }}
                ref={attachKeyListenRef}
                tabIndex="-1"
                onKeyDown={detectKeyDown}
                onBlur={(e) => {
                    if (test.freeField) {
                        e.target.focus({
                            preventScroll: true,
                        });
                    }
                }}
            >
                <SesHeader clientCobranding={location.state.cobrandingLink} />
                <div
                    ref={stepRef}
                    className="top-progress-container flex_row sticky full-width g3"
                >
                    <CommonQuesProgress test={test} />
                    {!location.state.warmUp &&
                        location.state.test.bShowTimer &&
                        location.state.test.timeLimit ? (
                        <ProgressBar
                            circular
                            step={totalSecLeft}
                            steps={assessmentTimerStarted.current}
                        />
                    ) : (
                        <></>
                    )}
                </div>

                <div className="flex_col g2">
                    <h3>
                        {location.state.warmUp
                            ? location.state.test.testExampleName
                            : location.state.test.name}
                    </h3>
                    <div
                        className="base"
                        dangerouslySetInnerHTML={{
                            __html: test.questions[0].topicInstruction,
                        }}
                    />
                </div>
                <form
                    ref={formRef}
                    className={
                        location.state.test.displayType === "3"
                            ? "flex_col g2 position_relative"
                            : test.questions[0].allowRanking
                                ? "flex_col g2 position_relative"
                                : "flex_row flex_col_tablet g2 position_relative"
                    }
                >
                    <QuesLoader show={phase === "showing-loader"} />
                    <div className={`flex_col flex_gsb g2 shown ${phase}`}>
                        <div className="small-title">{phrases?.["13106"]}</div>
                        <div className="flex_col g2 base p4 roundness_1 border_tt82 full-height">
                            {location.state.test.displayType !== "3" &&
                                test.questions.map(
                                    (val, ind) =>
                                        val.questionImage && (
                                            <img
                                                key={val.id}
                                                src={buildMediaUrl(
                                                    val.questionImage
                                                )}
                                                alt="question-image"
                                                className="ques-img"
                                            />
                                        )
                                )}
                            {location.state.test.displayType !== "3" &&
                                test.questions.map(
                                    (val, ind) =>
                                        val.media &&
                                        val.media.map((media, ind) => (
                                            <img
                                                key={media.id}
                                                src={buildMediaUrl(media.url)}
                                                alt="question-image"
                                                className="ques-img"
                                            />
                                        ))
                                )}
                            {location.state.test.displayType !== "3" &&
                                test.questions.map(
                                    (val, ind) =>
                                        val.questionText && (
                                            <div
                                                key={val.id}
                                                className="questionText"
                                                dangerouslySetInnerHTML={{
                                                    __html: val.questionText,
                                                }}
                                            />
                                        )
                                )}
                            {location.state.test.displayType === "3" && (
                                <img
                                    src={buildMediaUrl(
                                        test.questions[0].questionImage
                                    )}
                                    alt="question-image"
                                />
                            )}
                        </div>
                    </div>
                    <div className={`flex_col flex_gsb g2 shown ${phase}`}>
                        <div className="flex_row justify-content_between">
                            <div className="small-title">
                                {test?.questions?.[0]?.answers.length > 0
                                    ? phrases?.["15138"]
                                    : phrases?.["26000043"]}
                            </div>
                            {!location.state.warmUp &&
                                location.state.test.timeByQuestion &&
                                location.state.test.bShowTimer && (
                                    <ul className="list-icon m0 p0 base">
                                        <li>
                                            <span className="material-icons-outlined icon-order">
                                                timer
                                            </span>
                                            {min}:{sec}
                                        </li>
                                    </ul>
                                )}
                        </div>

                        <div className="flex_col g2 base p4 roundness_1 border_tt82 full-height">
                            {test.questions[0].allowRanking ? (
                                <DragDrop
                                    setDefaultOrderData={setDefaultOrderData}
                                    defaultOrderData={defaultOrderData}
                                    orderData={orderData}
                                    setOrderData={setOrderData}
                                    test={test}
                                    maxSelection={
                                        test.questions[0].maxSelection
                                    }
                                />
                            ) : (
                                <>
                                    <fieldset
                                        aria-label="group-container"
                                        className="radio-group-container"
                                    >
                                        {test.questions[0].answers?.[0]
                                            ?.groupId === "1" &&
                                            test.questions[0].answers.map(
                                                (val, ind) => (
                                                    <div
                                                        key={
                                                            test.startNumber +
                                                            ind
                                                        }
                                                        className="radio-container"
                                                    >
                                                        <input
                                                            id={`option-${ind}`}
                                                            type="radio"
                                                            name="survey_options"
                                                            value={val.position}
                                                            onChange={(e) =>
                                                                setSingleSelectData(
                                                                    e.target
                                                                        .value
                                                                )
                                                            }
                                                            checked={
                                                                singleSelectData ==
                                                                val.position
                                                            }
                                                        />
                                                        <label
                                                            dangerouslySetInnerHTML={{
                                                                __html: val.content,
                                                            }}
                                                            htmlFor={`option-${ind}`}
                                                        />
                                                    </div>
                                                )
                                            )}
                                    </fieldset>
                                    {test.questions[0].answers?.[0]?.groupId ===
                                        "2" &&
                                        test.questions[0].answers.map(
                                            (val, ind) => (
                                                <div
                                                    key={test.startNumber + ind}
                                                    className="checkbox-container"
                                                >
                                                    <input
                                                        id={`option-${ind}`}
                                                        type="checkbox"
                                                        value={val.position}
                                                        checked={
                                                            multiSelectData[
                                                            val.position
                                                            ]
                                                        }
                                                        onClick={(e) =>
                                                            updateMultiSelect(
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                    <label
                                                        dangerouslySetInnerHTML={{
                                                            __html: val.content,
                                                        }}
                                                        htmlFor={`option-${ind}`}
                                                    />
                                                </div>
                                            )
                                        )}
                                    {test.questions[0].answers?.[0]?.groupId ===
                                        "3" && (
                                            <div key={test.startNumber}>
                                                <input
                                                    id={`option-${test.startNumber}`}
                                                    type="text"
                                                    value={textData}
                                                    autocomplete="off"
                                                    autocorrect="off"
                                                    autocapitalize="off"
                                                    spellcheck="false"
                                                    onChange={(e) =>
                                                        setTextData(e.target.value)
                                                    }
                                                    onKeyDown={(e) => {
                                                        e.stopPropagation();
                                                        if (e.code === "Enter") {
                                                            e.preventDefault();
                                                            if (nextAllowed()) {
                                                                nextNavigate();
                                                            }
                                                        }
                                                    }}
                                                />
                                            </div>
                                        )}
                                </>
                            )}
                            {test.questions[0].freeField && (
                                <div className="input-wrapper surveyPg">
                                    <textarea
                                        ref={textAreaRef}
                                        onChange={(e) => {
                                            setFreeFieldData(e.target.value);
                                        }}
                                        autocomplete="off"
                                        autocorrect="off"
                                        autocapitalize="off"
                                        spellcheck="false"
                                        onKeyDown={(e) => {
                                            e.stopPropagation();
                                            if (
                                                e.key === "F12" ||
                                                e.keyCode === 123
                                            ) {
                                                e.preventDefault();
                                            }
                                            if (
                                                e.ctrlKey &&
                                                e.shiftKey &&
                                                e.key === "I"
                                            ) {
                                                e.preventDefault();
                                            }
                                        }}
                                        value={freeFieldData}
                                        id="freeFieldId"
                                        onPaste={handlePasteTemp}
                                        onCopy={handleCopyTemp}
                                        onContextMenu={handleContextMenu}
                                    />
                                </div>
                            )}
                            {menuVisible && (
                                <div
                                    ref={divRef}
                                    style={{
                                        position: "absolute",
                                        top: menuPosition.y,
                                        left: menuPosition.x,
                                    }}
                                >
                                    <ul
                                        class="tag-ds dropdown-menu bottom adecco"
                                        id="dropdown-menu"
                                        aria-labelledby="undefined-btn"
                                    >
                                        <span>
                                            <li onClick={handleCopy}>
                                                <a class="dropdown-item justify-content_between">
                                                    <span>
                                                        {phrases?.["26000072"]}
                                                    </span>
                                                    <span>Ctrl+C</span>
                                                </a>
                                            </li>
                                            <li onClick={handlePaste}>
                                                <a class="dropdown-item justify-content_between">
                                                    <span>
                                                        {phrases?.["26000073"]}
                                                    </span>
                                                    <span>Ctrl+P</span>
                                                </a>
                                            </li>
                                            <li onClick={handleSelectAll}>
                                                <a class="dropdown-item justify-content_between">
                                                    <span>
                                                        {phrases?.["26000071"]}
                                                    </span>
                                                    <span>Ctrl+A</span>
                                                </a>
                                            </li>
                                        </span>
                                    </ul>
                                </div>
                            )}
                        </div>
                    </div>
                </form>
                <hr />
                <div className="flex_col_reverse_mobile flex_row align-items_center justify-content_between g2">
                    {test.lastPage && !location.state.warmUp ? (
                        <div />
                    ) : (
                        <button
                            className="button-secondary text_uppercase full-width_mobile"
                            onClick={exitTest}
                            disabled={loading}
                        >
                            {location.state.warmUp
                                ? phrases?.["1000229"]
                                : phrases?.["1002190"]}
                        </button>
                    )}
                    <div className="flex g4 text_uppercase">
                        {test.startNumber !== 1 &&
                            location.state.test.previosNavegation && (
                                <a
                                    role="link"
                                    onClick={() => nextNavigate(true)}
                                    className={`full-width_mobile ${loading ? "disabled" : ""
                                        }`}
                                >
                                    <span className="material-icons left">
                                        arrow_back
                                    </span>
                                    {phrases?.["410"]}
                                </a>
                            )}
                        <button
                            className="button-primary text_uppercase full-width_mobile"
                            disabled={!nextAllowed() || loading}
                            onClick={() => nextNavigate()}
                        >
                            {test.lastPage
                                ? location.state.warmUp
                                    ? phrases?.["11070"]
                                    : phrases?.["15140"]
                                : phrases?.["10976"]}
                            <span className="material-icons right">
                                arrow_forward
                            </span>
                        </button>
                    </div>
                </div>
            </div>
            <CommonPopup
                popupData={popupData}
                closeAction={closePopUp}
                approveAction={approveAction}
                setterFun={setpopupData}
            />
        </>
    );
};

export default SurveyQues;
